import { handleActions } from 'redux-actions';
import { reject } from 'lodash';

import {
  compareAdd,
  CompareAddPayload,
  compareRemove,
  CompareRemovePayload,
  compareRemoveAll,
  stateReset,
  stateUpdate,
  State,
} from './action';

const initialState: State = {
  comparableHealthQuotes: [],
};

const reducer = handleActions(
  {
    [String(compareAdd)]: (state, { payload }) => {
      const { healthQuote } = payload as unknown as CompareAddPayload;

      return {
        ...state,
        comparableHealthQuotes: [...state.comparableHealthQuotes, healthQuote],
      };
    },

    [String(compareRemove)]: (state, { payload }) => {
      const { healthQuote } = payload as unknown as CompareRemovePayload;

      return {
        ...state,
        comparableHealthQuotes: reject(state.comparableHealthQuotes, healthQuote),
      };
    },

    [String(compareRemoveAll)]: (state) => {
      return {
        ...state,
        comparableHealthQuotes: [],
      };
    },

    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },

    [String(stateReset)]: () => {
      return initialState;
    },
  },

  initialState,
);

export default reducer;
